/**
 * CK | Wishlist slide-to-remove prompt
 *
 * Intercepts the minus-button click when a cart item is at qty 1.
 * Instead of removing the item immediately, slides the row to the
 * right and reveals a "Move to Wishlist?" panel.
 *
 * Yes — placeholder (no-op until a real wishlist is wired up).
 * No  — removes the item from the cart.
 */
(function () {
  'use strict';

  function getStorageKey() {
    return window.__ck_customer_id
      ? 'ck_wishlist_' + window.__ck_customer_id
      : 'ck_wishlist_guest';
  }

  function readWishlist(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '[]');
    } catch (err) {
      return [];
    }
  }

  function writeWishlist(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {}
  }

  function addWishlistItem(item) {
    var key = getStorageKey();
    var list = readWishlist(key);
    var exists = list.find(function (existing) {
      return existing.id === item.id;
    });

    if (exists) {
      if (item.selected_variant_id) exists.selected_variant_id = item.selected_variant_id;
      writeWishlist(key, list);
      return;
    }

    list.push(item);
    writeWishlist(key, list);
  }

  function parseJSON(value) {
    try {
      return JSON.parse(value || 'null');
    } catch (err) {
      return null;
    }
  }

  function buildWishlistItemFromCartItem(cartItem) {
    var productId = parseInt(cartItem.dataset.productId, 10);
    if (!productId) return null;

    return {
      id: productId,
      handle: cartItem.dataset.productHandle || '',
      title: cartItem.dataset.productTitle || '',
      price: parseInt(cartItem.dataset.productPrice, 10) || 0,
      compare_at_price: parseInt(cartItem.dataset.productComparePrice, 10) || 0,
      image: cartItem.dataset.productImage || '',
      url: cartItem.dataset.productUrl || '',
      variants: parseJSON(cartItem.dataset.productVariants),
      options: parseJSON(cartItem.dataset.productOptions),
      selected_variant_id: parseInt(cartItem.dataset.selectedVariantId, 10) || null,
    };
  }

  /**
   * Capture-phase listener on document.
   * Fires BEFORE the theme's QtySelector click handler reaches the button,
   * so we can stop propagation and prevent the default qty-change logic.
   */
  document.addEventListener(
    'click',
    function (e) {
      var minusBtn = e.target.closest(
        '.ck-wishlist-item .js-qty__adjust--minus'
      );
      if (!minusBtn) return;

      var wrapper = minusBtn.closest('.js-qty__wrapper');
      if (!wrapper) return;

      var input = wrapper.querySelector('.js-qty__num');
      if (!input) return;

      var qty = parseInt(input.value, 10);
      if (qty !== 1) return;

      e.stopPropagation();
      e.preventDefault();

      var cartItem = minusBtn.closest('.ck-wishlist-item');
      if (!cartItem) return;

      cartItem.classList.add('is-sliding');
    },
    true
  );

  /* --- Yes / No button handlers (bubble phase, delegated) --- */

  document.addEventListener('click', function (e) {
    var yesBtn = e.target.closest('[data-ck-wishlist-yes]');
    if (!yesBtn) return;

    var cartItem = yesBtn.closest('.ck-wishlist-item');
    if (!cartItem) return;

    var key = cartItem.dataset.key;
    if (!key) return;

    var wishlistItem = buildWishlistItemFromCartItem(cartItem);
    if (!wishlistItem) return;

    // Show loading state immediately
    yesBtn.disabled = true;
    var noBtn = cartItem.querySelector('[data-ck-wishlist-no]');
    if (noBtn) noBtn.disabled = true;
    cartItem.classList.add('is-loading');

    addWishlistItem(wishlistItem);
    document.dispatchEvent(new CustomEvent('ck:wishlist:updated'));

    theme.cart.changeItem(key, 0).then(function (cart) {
      var parsed = JSON.parse(cart);

      // Switch to confirmed state, then rebuild cart after a short pause
      cartItem.classList.remove('is-loading');
      cartItem.classList.add('is-confirmed');
      var confirmedEl = cartItem.querySelector('.ck-wishlist-panel__confirmed');
      if (confirmedEl) confirmedEl.removeAttribute('aria-hidden');

      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: parsed },
          })
        );

        // Only redirect to wishlist if the cart is now empty.
        if (parsed.item_count === 0) {
          var wishlistToggle = document.querySelector('[data-ck-wishlist-toggle]');
          if (wishlistToggle) wishlistToggle.click();
        }
      }, 800);
    });
  });

  document.addEventListener('click', function (e) {
    var noBtn = e.target.closest('[data-ck-wishlist-no]');
    if (!noBtn) return;

    var cartItem = noBtn.closest('.ck-wishlist-item');
    if (!cartItem) return;

    var key = cartItem.dataset.key;
    if (!key) return;

    noBtn.disabled = true;

    theme.cart.changeItem(key, 0).then(function (cart) {
      var parsed = JSON.parse(cart);

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: parsed },
        })
      );
    });
  });
})();
